import { createFileRoute } from "@tanstack/react-router";

// Bez extra permission guardu — nastavení vlastního účtu je dostupné každému
// přihlášenému uživateli (auth už vynucuje dashboard layout).
export const Route = createFileRoute("/dashboard/nastaveni")({});
